var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "device-setting-info-component",
      class: _vm.roomInfo.roomType,
      attrs: { "data-grm-comp": "DeviceSettingInfo" },
    },
    [
      _c("div", { staticClass: "device-setting-info" }, [
        _c(
          "div",
          { staticClass: "device-set-info" },
          [
            _c("div", { staticClass: "device-set-info-header pc" }, [
              _c("button", {
                staticClass: "back-btn",
                on: { click: _vm.handleClickBackBtn },
              }),
            ]),
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.isShowInfo
                ? _c("div", { staticClass: "device-set-info-body" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.onToggleInfo,
                            expression: "onToggleInfo",
                          },
                        ],
                        staticClass: "device-set-info-title-container",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "device-set-info-room-type" },
                          [
                            _c(
                              "h2",
                              { staticClass: "device-set-info-room-type-text" },
                              [_vm._v(_vm._s(_vm.roomType))]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "device-set-info-title-wrapper" },
                          [
                            _c("p", { staticClass: "device-set-info-title" }, [
                              _vm._v(_vm._s(_vm.roomInfo.roomTitle)),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "device-set-info-check-wrapper" },
                          [
                            _c("p", {
                              staticClass:
                                "device-set-info-check roomDescription",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("deviceSetting.info.check")
                                ),
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "device-set-info-check-wrapper" },
                          [
                            _c("p", {
                              staticClass:
                                "device-set-info-check roomDescription",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("deviceSetting.info.warn")
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "device-set-info-footer pc" }, [
              _c("div", { staticClass: "device-set-join-btn-wrapper" }, [
                _c(
                  "button",
                  {
                    ref: "join",
                    staticClass: "default-btn join-request-btn",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("reqJoin")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("deviceSetting.preview.join.title")))]
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }